import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { Reveal } from './Reveal';
import { ConfettiRain } from './ConfettiRain';
import { included } from '../data/content';
const tints = ['#FDEAEC', '#E6F2FB', '#E9F6EE', '#FFF7E4'];
export function WhatsIncluded() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream py-16 sm:py-20" aria-labelledby="included-title" data-id="element-360" data-mp="pvnr6ouenp33">
      <ConfettiRain count={12} opacity={0.4} data-id="element-361" data-mp="utfpq1pk29g9" />

      <div className="relative mx-auto max-w-content px-5 sm:px-8" data-id="element-362" data-mp="us4p2arephtd">
        <Reveal data-id="element-363" data-mp="gu7ol39u0r9f">
          <h2 id="included-title" className="mx-auto max-w-2xl text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-364" data-mp="gwtwj40mx8s6">
            Un año entero de ideas en{' '}
            <span className="text-sky" data-id="element-365" data-mp="36kkvm5ai2zxx">un solo lugar</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-366" data-mp="1whfbdly09uab">
          {included.map((b, i) => <Reveal as="article" key={b.title} delay={i * 0.06} data-id="element-367" data-mp="1rjnnd30hesbe" data-mpi={i}>
              <div className="h-full rounded-3xl p-6 shadow-soft transition-transform duration-300 hover:-translate-y-1.5 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
            backgroundColor: tints[i % tints.length],
            borderTop: `5px solid ${b.accent}`
          }} data-id="element-368" data-mp="26fv23nt4f1ja">
                <motion.span className="inline-flex text-3xl" aria-hidden="true" animate={reduce ? undefined : {
              y: [0, -7, 0],
              rotate: [-4, 4, -4]
            }} transition={{
              duration: 4 + i % 3,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} data-id="element-369" data-mp="2afdn0jkxzcm4">
                  {b.emoji}
                </motion.span>
                <h3 className="mt-3 font-display text-base font-extrabold uppercase" style={{
              color: b.accent
            }} data-id="element-370" data-mp="31agriin04n98">
                  {b.title}
                </h3>
                <p className="mt-2 font-sans text-sm leading-relaxed text-muted" data-id="element-371" data-mp="3b4yzw13d56zd">
                  {b.description}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}